import React,{useState,useEffect,useRef} from 'react';
import '../../CSS/index.css';
import { connect } from 'react-redux';
import { StyledSubHeading } from '../../CSS/style';
import themeSettings from '../../../../commons/styles/themeSettings.json';
import { Button, Checkbox, Form, Input, message, Radio, Modal } from 'antd';
import { RBSLOOKUPMaster, ServerRegistrationMasters } from '../../../../commons/api';
import { getMetaData, submitDataSource, 
  // getDeployHistory 
} from '../../Utils/FormCalls';
const APIList = {
  getById: `${ServerRegistrationMasters.GET}`,
  getMetrics: `${RBSLOOKUPMaster.LookUpItemsGetById}`,
  createData: `${ServerRegistrationMasters.CREATE}`
};
const ServerRegistrationDetails = (props) => {
  const [formObject, setFormObject] = useState({});
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
 // const [typeList, setTypeList] = useState({});
  //const [subTypeList, setSubTypeList] = useState({});
  const [checkedVal, setCheckedVal] = useState(false);
  const [CheckedFlag, setCheckedFlag] = useState(true);
  // const [edit] =useState([]);
  const [value, setValue] = useState('TrainingServerFlag');
  const [modalVisible, setModalVisible] = useState(false);
  const [newOption, setNewOption] = useState('');
  const hRef = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      let path = props.location.pathname.split('/rubus/RbsAnalytics/ServerRegistrationDetails/');
      let Id = path && path[1] ? path[1] : null;
      if (Id) {
        let data = await getMetaData(APIList.getById, 'Id', Id);
        let formObject = data && data[0] ? data[0] : {};
        if (formObject.ServerType === 'InferenceServerFlag') {
          setValue('InferenceServerFlag');
        } else {
          setValue(formObject.ServerType);
        }
      //  var subType = await getDeployHistory(APIList.getMetrics, 'LookupName', formObject.Type);
        setCheckedVal(formObject.GMLFlowAvailableFlag === true);
        setCheckedFlag(formObject.GPUFlag === true);
        if (hRef.current) {
          hRef.current.setFieldsValue(formObject );
        }
        setFormObject(formObject);
      //  setSubTypeList(subType);
        //setSelectedType(formObject.Type);
      }
    };
    fetchData();
  }, [props.location.pathname]);
  useEffect(() => {
    if (props.userProfile !== userProfile || props.translationCache !== translationCache) {
      setUserProfile(props.userProfile);
      setTranslationCache(props.translationCache);
    }
  }, [props.userProfile, props.translationCache]);
  const onFormSubmit = () => {
    hRef.current.validateFields()
      .then(async (values) => {
        values = {
          ...hRef.current.getFieldsValue(),
          ServerType: value,
          GPUFlag: CheckedFlag,
          GMLFlowAvailableFlag: value === 'InferenceServerFlag' ? checkedVal : undefined
        };
        let response = await submitDataSource(APIList.createData, values);
        // const Id = response && response.Id ? response.Id : null;
        // let metaData = await getMetaData(APIList.getById, 'Id', Id);
        // this.setState({ formObject: metaData });
        message.success(response && response.message ? translation(response.message) : '');
        props.navigate('/rubus/RbsAnalytics/ServerRegistrationList');
      })
      .catch(() => { });
  };
  const resetFields = () => {
    hRef.current && hRef.current.setFieldsValue({
      Name: undefined,
      Description: undefined,
      IpAddress: undefined,
      GPUFlag: true,
      TrainingHome: undefined,
      InferenceHome: undefined,
      MLFlowBackboneDB: undefined,
      MLFlowArtifactsLocation: undefined,
      MLFlowIPAddress: undefined,
      Port: undefined,
      UserName: undefined,
      MLFlowPassword: undefined
    });
    setFormObject({});
    setCheckedVal(false);
    setCheckedFlag(true);
    setValue('TrainingServerFlag');
  };
  // const onTypeSelect = async (value) => {
  //   let subType = await getDeployHistory(APIList.getMetrics, 'LookupName', value);
  //   //setSubTypeList(subType);
  //  // setselectedType(value);
  // };
  const onCheckboxChange = (e) => {
    setCheckedVal(e.target.checked);
  };
  const onCheckboxFlagChange = (e) => {
    setCheckedFlag(e.target.checked);
  };
  const handleModalConfirm = () => {
    hRef.current && hRef.current.setFieldsValue({
      TrainingHome: undefined,
      InferenceHome: undefined,
      MLFlowBackboneDB: undefined,
      MLFlowArtifactsLocation: undefined,
      MLFlowIPAddress: undefined,
      Port: undefined,
      UserName: undefined,
      MLFlowPassword: undefined
    });
    setValue(newOption);
    setModalVisible(false);
    setCheckedVal(false);
  };
  const handleModalCancel = () => {
    setModalVisible(false);
  };
  const onChange = (e) => {
    let newOption = e.target.value;
    let data = hRef.current && hRef.current.getFieldValue('TrainingHome');
    let values = hRef.current && hRef.current.getFieldValue('InferenceHome');
    if ((data && data !== undefined) || values !== undefined || checkedVal === true) {
      setNewOption(newOption);
      setModalVisible(true);
    } else {
      setValue(newOption);
    }
  };
  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
    const validateMessages = {
      required: translation('${label}') + translation('is required!')
    };
    const formItemLayout = { width: '100%', flex: '50%' };
    return (
      <>
        <StyledSubHeading theme={themeSettings}>
          {translation('Server Registration')}
        </StyledSubHeading>
        <Form 
          name="ServerRegistration"
          ref={hRef}
          autoComplete="off"
          initialValues={formObject}
          theme={themeSettings}
          layout="horizontal"
          labelCol={{ flex: '200px' }}
          labelAlign="right"
          onFinish={onFormSubmit}
         // onFinishFailed={onFinishFailed}
          // disabled={view === true ? true : false}
          labelWrap
          validateMessages={validateMessages}
          wrapperCol={{ flex: 1 }}
        >
          <div style={{ display: 'flex', flexWrap: 'wrap', paddingRight: '5%' }}>
            <Form.Item name="Id"></Form.Item>
            <Form.Item
              label={translation('Name')}
              name="Name"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Input
                style={{ width: '380px' }}
                // disabled={formObject && formObject.Name ? true : false}
                placeholder={translation('Please Enter Name')}
              ></Input>
            </Form.Item>
            <Form.Item
              label={translation('Description')}
              name="Description"
              // rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Input
                style={{ width: '380px' }}
                // disabled={formObject && formObject.Description ? true : false}
                placeholder={translation('Please Enter Description')}
              ></Input>
            </Form.Item>
            <Form.Item
              label={translation('IP Address')}
              name="IpAddress"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Input
                style={{ width: '380px' }}
                // disabled={formObject && formObject.IPAddress ? true : false}
                placeholder={translation('Please Enter IP Address')}
              ></Input>
            </Form.Item>
            <Form.Item
              label={translation('GPU Flag')}
              name="GPUFlag"
              // rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Checkbox
                style={{ width: '380px' }}
                checked={CheckedFlag === true ? true : false}
                onClick={(e) => onCheckboxFlagChange(e)}
              />
            </Form.Item>
            <Form.Item>
              <Modal
                className="ServerRegistrationModal"
                closable={false}
                title={null}
                open={modalVisible}
                onOk={handleModalConfirm}
                cancelText={translation('No')}
                okText={translation('Yes')}
                onCancel={handleModalCancel}
              >
                Are you want to change the option. If you try to change the option, you will lose
                data
              </Modal>
              <Radio.Group
                onChange={onChange}
                value={value}
                style={{ width: '100%', paddingLeft: '600px' }}
              >
                <Radio value={'TrainingServerFlag'} >
                  Training Server Flag
                </Radio>
                <Radio
                  value={'InferenceServerFlag'}
                  style={{ paddingLeft: '100px' }}
                >
                  Inference Server Flag
                </Radio>
              </Radio.Group>
            </Form.Item>
            {value && value === 'TrainingServerFlag' ? (
              <Form.Item
                label={translation('Training Home')}
                name="TrainingHome"
                // rules={[{ required: true }]}
                style={formItemLayout}
              >
                <Input
                  style={{ width: '380px' }}
                  // disabled={formObject && formObject.TrainingHome ? true : false}
                  placeholder={translation('Please Enter Training Home')}
                ></Input>
              </Form.Item>
            ) : null}
            {value && value === 'InferenceServerFlag' ? (
              // <>
              <div className="ServerDiv">
                <Form.Item
                  label={translation('Inference Home')}
                  name="InferenceHome"
                  // rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <Input
                    style={{ width: '380px' }}
                    // disabled={formObject && formObject.InferenceHome ? true : false}
                    placeholder={translation('Please Enter Inference Home')}
                  ></Input>
                </Form.Item>
                <Form.Item
                  label={translation('Model Server Available')}
                  name="GMLFlowAvailableFlag"
                  style={formItemLayout}
                >
                  <Checkbox
                    style={{ width: '380px' }}
                    checked={checkedVal === true ? true : false}
                    onClick={(e) => onCheckboxChange(e)}
                  />
                </Form.Item>
                <Form.Item
                  label={translation('Model Server  Type')}
                  name="MLFlowBackboneDB"
                  // rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <Input
                    style={{ width: '380px' }}
                    disabled={checkedVal && checkedVal === true ? false : true}
                    placeholder={translation('Please Enter Model Server Type')}
                  ></Input>
                </Form.Item>
                <Form.Item
                  label={translation('Model Server Artifacts Location')}
                  name="MLFlowArtifactsLocation"
                  // rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <Input
                    style={{ width: '380px' }}
                    disabled={checkedVal && checkedVal === true ? false : true}
                    placeholder={translation('Please Enter Model Server Artifacts Location')}
                  ></Input>
                </Form.Item>
                <Form.Item
                  label={translation('IP Address')}
                  name="MLFlowIPAddress"
                  // rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <Input
                    style={{ width: '380px' }}
                    disabled={checkedVal && checkedVal === true ? false : true}
                    placeholder={translation('Please Enter Ip Address')}
                  ></Input>
                </Form.Item>
                <Form.Item
                  label={translation('Port')}
                  name="Port"
                  // rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <Input
                    style={{ width: '380px' }}
                    disabled={checkedVal && checkedVal === true ? false : true}
                    placeholder={translation('Please Enter Port')}
                  ></Input>
                </Form.Item>
                <Form.Item
                  label={translation('User Name')}
                  name="UserName"
                  // rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <Input
                    style={{ width: '380px' }}
                    disabled={checkedVal && checkedVal === true ? false : true}
                    placeholder={translation('Please Enter User Name')}
                  ></Input>
                </Form.Item>
                <Form.Item
                  label={translation('Password')}
                  name="MLFlowPassword"
                  // rules={[{ required: true }]}
                  style={formItemLayout}
                >
                  <Input
                    style={{ width: '380px' }}
                    type="password"
                    disabled={checkedVal && checkedVal === true ? false : true}
                    placeholder={translation('Please Enter Password')}
                  ></Input>
                </Form.Item>
              </div>
            ) : // </>
              null}
          </div>
          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <Form.Item>
              <Button
                style={{ marginRight: 8 }}
                theme={themeSettings}
                type="primary"
                htmlType="submit"
                data-testid="submitButton"
              >
                {formObject && formObject.Id ? translation('Update') : translation('Submit')}
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                style={{ marginRight: 8 }}
                theme={themeSettings}
                type="primary"
                danger
                onClick={() => resetFields()}
              >
                {translation('Reset')}
              </Button>
            </Form.Item>
          </div>
        </Form>
      </>
    );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(ServerRegistrationDetails);
